import PathURL from "./URL";
import store from "../store";
import cronstrue from "cronstrue/i18n";
import Vue from "vue";

const _phonePattern = /^((6(7[0-9]{7}|5[0-4]{1}[0-9]{6}|8[0-4]{1}[0-9]{6}))|(6(9[0-9]{7}|5[5-9]{1}[0-9]{6}|8[6-9]{1}[0-9]{6}))|(6(6[0-9]{7}|85[0-9]{6})))$/;

export const isPhone = (number) => {
  return _phonePattern.test(number);
};

export const dateIsGreatThan = (max, component) => {
  let end = new Date(max);
  let tempStart = component.start;
  let start = new Date(tempStart);
  return start.getTime() <= end.getTime();
};

export const isCron = (cron) => {
  try {
    cronstrue.toString(cron);
    return true;
  } catch (e) {
    return false;
  }
};

export const isUniqueUsername = (value, component) => {
  if (!Vue._.has(value, 'length') || value === null || value.length < 3 || value.length > 10 || component['oldUsername'] === value) {
    return true
  }
  return new Promise((resolve) => {
    store
      .dispatch("request", {
        url: PathURL.USER.UNIQUE_USERNAME.URI,
        method: PathURL.USER.UNIQUE_USERNAME.METHOD,
        data: {
          username: value
        }
      })
      .then(() => {
        resolve(false);
      })
      .catch(() => {
        resolve(true);
      })
  })

};

export const isUniqueApplicationName = (value, component) => {
  if (!Vue._.has(value, 'length') || value === null || value.length < 3 || value.length > 10 || component['oldName'] === value) {
    return true
  }
  return new Promise((resolve) => {
    store
      .dispatch("request", {
        url: PathURL.APPLICATION.UNIQUE_NAME.URI,
        method: PathURL.APPLICATION.UNIQUE_NAME.METHOD,
        data: {
          name: value,
          userId: component.user
        }
      })
      .then(() => {
        resolve(false);
      })
      .catch(() => {
        resolve(true);
      })
  })

};
